import script from "./MainBottom.vue?vue&type=script&setup=true&lang=js"
export * from "./MainBottom.vue?vue&type=script&setup=true&lang=js"

import "./MainBottom.vue?vue&type=style&index=0&id=65003da9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65003da9"]])

export default __exports__